import clsx from "clsx"
import { Link } from "react-router-dom"

export default function HeaderNavLink(
    {
        to,
        children,
        className
    }
){
    return (
        <Link to={to} className={clsx(
            "px-[1.7rem] small-computer:px-[1rem] py-[1rem] font-bold text-[1.41625rem] small-computer:text-[1.25rem] mobile:text-heading-4 small-computer:text-large whitespace-nowrap transition-all hover:opacity-50",
            className
        )}>
            {children}
        </Link>
    )
}